<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          text
          rounded
          class="ma-3"
          color="green darken-3"
          >ADD FIRM</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
        "
      >
        <v-card-title>
          <span>ADD </span><span class="red--text">FIRM</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddFirm" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <div>Add a New Firm</div>
              <div class="ma-2 mt-2">
                <v-text-field
                  class="ma-2 mt-6"
                  autofocus
                  outlined
                  v-model="firmName"
                  multiple
                  label="ENTER FIRM NAME (required)"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="firmAddressLine"
                  multiple
                  label="ENTER STREET ADDRESS(required)"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="firmCityStateZip"
                  multiple
                  label="ENTER CITY, STATE and ZIP (required)"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="firmPhone"
                  multiple
                  label="ENTER PHONE(required)"
                  color="#2E5473"
                  dense
                  filled
                  v-mask="mask"
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="firmFax"
                  multiple
                  label="ENTER FAX"
                  color="#2E5473"
                  dense
                  filled
                  v-mask="mask"
                ></v-text-field>

                <div v-for="(attorney, i) in attorneys" :key="i">
                  <v-card
                    style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800"
                    outlined
                    tile
                    rounded
                    class="ma-auto"
                    dense
                  >
                    <v-text-field
                      class="ma-2 mt-6"
                      outlined
                      v-model="attorneys[i].name"
                      multiple
                      label="EDIT ATTORNEY"
                      color="#2E5473"
                      dense
                      filled
                    ></v-text-field>
                    <v-text-field
                      class="ma-2 mt-6"
                      outlined
                      v-model="attorneys[i].barNumber"
                      multiple
                      label="EDIT BAR NUMBER"
                      color="#2E5473"
                      dense
                      filled
                    ></v-text-field>
                    <v-text-field
                      class="ma-2 mt-6"
                      outlined
                      v-model="attorneys[i].email"
                      multiple
                      label="EDIT EMAIL"
                      color="#2E5473"
                      dense
                      filled
                    ></v-text-field>
                  </v-card>
                </div>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="addingAttorney.name"
                  multiple
                  label="ENTER ATTORNEY NAME"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="addingAttorney.barNumber"
                  multiple
                  label="ENTER ATTORNEY BAR NUMBER"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-text-field
                  class="ma-2 mt-6"
                  outlined
                  v-model="addingAttorney.email"
                  multiple
                  label="ENTER ATTORNEY EMAIL"
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
                <v-btn v-if="addingAttorney" @click="onAddAttorney"
                  >ADD ATTORNEY TO FIRM</v-btn
                >
              </div>
              <!-- <v-card>
                <ol class="ma-auto">
                  <li v-for="(attorney, index) in attorneys" :key="index">
                    <v-layout>
                      <div class="ma-auto">{{ attorney.name }}, SBN: {{attorney.barNumber}}</div>
                      <v-btn small text rounded @click="removeAttorney(index)">
                        <v-icon color="red">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-layout>
                  </li>
                </ol>
              </v-card>-->
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >ADD</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 * this component allows the user to add a firm to the matter
 
 * //todo: change this to allow for attorneys that are not part of the firm (associated counsel)
 * or create an "AddAssociatedAttorney" component that will add an associated attorney to the matter
 * or allow the user to add a service list item to the pleadings as associated councel.
 */
import * as firebase from "firebase";
import { mask } from "vue-the-mask";

export default {
  props: ["matter"],
  directives: {
    mask
  },
  data() {
    return {
      firmName: null,
      firmAddressLine: null,
      firmCityStateZip: null,
      firmPhone: null,
      firmFax: null,
      attorneys: [],
      addingAttorney: {
        name: null,
        barNumber: null
      },

      dialog: false,
      existingAttorney: null,
      mask: "(###) ###-####"
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // matter() {
    //   return this.$store.getters.;
    // },
    formIsValid() {
      return this.firmName !== null && this.firmName !== this.firm.firmName;
    },
    firm() {
      return this.$store.getters.firm;
    }
  },
  watch: {
    // name(val) {
    //   if (val !== null && val !== undefined) {
    //     this.existingAttorney = null;
    //   }
    // },
    // barNumber(val) {
    //   if (val !== null && val !== undefined) {
    //     this.existingAttorney = null;
    //   }
    // },
    // existingAttorney(val) {
    //   if (val !== null && val !== undefined) {
    //     this.name = null;
    //     this.barNumber = null;
    //   }
    // },
  },
  methods: {
    // // onFilePicked() {
    // //   if (event.target.files) {
    // //     const fileList = Array.from(event.target.files);
    // //     fileList.forEach(file => {
    // //       this.initialDocs.push(file);
    // //     });
    // //   }
    // // },

    // // removeAttorney(index) {
    // //   this.attorneys.splice(index, 1);
    // // },
    // clearExistingAttorneys() {
    //   this.existingAttorney = null;
    // },
    // clearNameAndBar() {
    //   this.name = null;
    //   this.barNumber = null;
    //   this.dialog = false;
    // },
    onAddAttorney() {
      this.attorneys.push({
        name: this.addingAttorney.name,
        barNumber: this.addingAttorney.barNumber,
        fullName: `${this.addingAttorney.name}, SBN ${this.addingAttorney.barNumber}`
      });
      this.addingAttorney = {
        name: null,
        barNumber: null
      };
    },
    onAddFirm() {
      if (this.formIsValid) {
        let firm = {
          firmName: this.firmName,
          firmAddressLine: this.firmAddressLine,
          firmCityStateZip: this.firmCityStateZip,
          firmPhone: this.firmPhone,
          firmFax: this.firmFax,
          attorneys: this.attorneys
        };
        firebase
          .firestore()
          // .collection("firms")
          // .doc(this.user.firmSlug)
          .collection("matters")
          .doc(this.matter.matterSlug)
          .update({
            firms: firebase.firestore.FieldValue.arrayUnion(firm)
          });
        this.firmName = null;
        this.firmAddressLine = null;
        this.firmCityStateZip = null;
        this.firmPhone = null;
        this.firmFax = null;
        this.attorneys = [];

        this.addingAttorney.name = null;
        this.addingAttorney.bar = null;
      }
    },
    cancelDialog() {
      this.firmName = null;
      this.firmAddressLine = null;
      this.firmCityStateZip = null;
      this.firmPhone = null;
      this.firmFax = null;
      this.attorneys = [];

      this.addingAttorney.name = null;
      this.addingAttorney.bar = null;

      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
